import { render, staticRenderFns } from "./ReplicacaoEmpresaCard.vue?vue&type=template&id=255fc93c&scoped=true&lang=pug"
import script from "./ReplicacaoEmpresaCard.vue?vue&type=script&lang=js"
export * from "./ReplicacaoEmpresaCard.vue?vue&type=script&lang=js"
import style0 from "./ReplicacaoEmpresaCard.vue?vue&type=style&index=0&id=255fc93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255fc93c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCheckbox,VDivider,VIcon})
